export const PERSON_GET = 'personGet'
export const PERSONS_GET = 'personsGet'
export const PERSON_CREATE = 'personCreate'
export const PERSON_UPDATE = 'personUpdate'